// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

export const processSlider = () => {
  const processSliderEl = '.process-slider';

  $(processSliderEl)
    .addClass('swiper')
    .append('<div class="swiper-button-prev">')
    .append('<div class="swiper-button-next">')
    .find('.wp-block-group__inner-container')
    .addClass('swiper-wrapper')
    .find('.wp-block-columns')
    .addClass('swiper-slide');

  new Swiper(processSliderEl, {
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  //advance process image gallery
  $('.process-slider').on('click', '.swiper-button-prev', function () {
    setTimeout(function () {
      $('.process-gallery .swiper-button-prev').trigger('click');
    }, 150);
  });

  $('.process-slider').on('click', '.swiper-button-next', function () {
    setTimeout(function () {
      $('.process-gallery .swiper-button-next').trigger('click');
    }, 150);
  });
};
